// @flow
import * as React from 'react';
import idx from 'idx';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import USER_GROUPS_QUERY from 'groups/queries/UserGroupsQuery.gql';
import USER_ORGS_QUERY from 'organizations/queries/UserOrganizationsQuery.gql';

import type { organizationDefault } from 'organizations/fragments/__generated__/organizationDefault';
import type { classesDefaults } from 'groups/fragments/__generated__/classesDefaults';

type Props = {
  children: Function,
  organizations: ?(organizationDefault[]),
  classes: ?(classesDefaults[]),
  orgsLoading: boolean,
  classesLoading: boolean,
  updateUserOrgs: (orgIds: number[]) => Promise<void>,
};

class UserSchoolsContainer extends React.Component<Props, void> {
  render() {
    return this.props.children({
      loading: this.props.orgsLoading || this.props.classesLoading,
      organizations: this.props.organizations,
      classes: this.props.classes,
      updateUserOrgs: this.props.updateUserOrgs,
    });
  }
}

const withOrgs = graphql(USER_ORGS_QUERY, {
  props: ({ data }) => ({
    organizations: idx(data, _ => _.me.organizations),
    orgsLoading: idx(data, _ => _.loading),
  }),
});
const withClasses = graphql(USER_GROUPS_QUERY, {
  props: ({ data }) => ({
    classes: idx(data, _ => _.me.classes),
    classesLoading: idx(data, _ => _.loading),
  }),
});

const withMutations = graphql(
  gql`
    mutation updateUserOrgs($orgIds: [Int!]!) {
      updateUserOrgs(input: { organization_ids: $orgIds }) {
        error {
          message
        }
      }
    }
  `,
  {
    props({ mutate }) {
      return {
        updateUserOrgs(orgIds: number[]) {
          return mutate({
            variables: { orgIds },
            refetchQueries: [
              {
                query: USER_ORGS_QUERY,
              },
            ],
          });
        },
      };
    },
  }
);

export { UserSchoolsContainer };

export default compose(withOrgs, withClasses, withMutations)(UserSchoolsContainer);
